import { h } from 'preact';

const Car = (props) => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" role="img" {...props}>
			<path
				d="M11.75,10.25C11.336,10.25,11,9.914,11,9.5s0.336-0.75,0.75-0.75S12.5,9.086,12.5,9.5S12.164,10.25,11.75,10.25
	z M4.25,7.25L5,2.75h6l0.75,4.5H4.25z M4.25,10.25c-0.414,0-0.75-0.336-0.75-0.75s0.336-0.75,0.75-0.75S5,9.086,5,9.5
	S4.664,10.25,4.25,10.25z M13.25,7.25H12.5l-0.75-4.5C11.75,2.336,11.414,2,11,2H5C4.586,2,4.25,2.336,4.25,2.75L3.5,7.25H2.75
	C2.336,7.25,2,7.586,2,8v3.75c0,0.414,0.336,0.75,0.75,0.75H3.5v0.75C3.5,13.664,3.836,14,4.25,14S5,13.664,5,13.25V12.5h6v0.75
	c0,0.414,0.336,0.75,0.75,0.75s0.75-0.336,0.75-0.75V12.5h0.75c0.414,0,0.75-0.336,0.75-0.75V8C14,7.586,13.664,7.25,13.25,7.25z"
			/>
		</svg>
	);
};

export default Car;
